import { createReducer } from '@reduxjs/toolkit';
import { getAllCompetenceCategories } from './actions';

//reducer
const initialState = {
  list: [],
};

export default createReducer(initialState, builder =>
  builder.addCase(getAllCompetenceCategories, (state, action) => {
    state.list = action.payload;
  })
);
